export const auditTableHeadings = ['User', 'Action', 'Timestamp', 'Details']